import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const state = () => ({
  sources: [],

  selectedVideoSource: null,
  selectedAudioSource: null,

  isReady: false,
  systemSupported: null,
  hasVideoDevice: false,
  deviceError: null
});

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
